import React from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import { V360ReportData } from "view360Card/models";
import { ReportBox } from "../reportBox/ReportBox";
import { LabeledReportItem } from "../labeledReportItem/LabeledReportItem";
import { constants } from "shared/constants";
import { Money } from "ecom-teams-apps-core";
import { formatNumberOrEmtpy } from "utils/formattingUtils";

export interface CumulativeProps {
    report: V360ReportData;
}

export const Cumulative: React.FC<CumulativeProps> = (props) => {
    const getNumericSeries = React.useMemo(
        () => props.report.seriesList.find((s) => s.unitType === constants.unitTypes.numeric),
        []
    );
    const getPercentageSerires = React.useMemo(
        () => props.report.seriesList.find((s) => s.unitType === constants.unitTypes.percentage),
        []
    );

    const getCumulative = () => {
        return (
            <Flex gap="gap.medium">
                {getNumericSeries && getNumericSeries.dataset.length > 0 && (
                    <LabeledReportItem
                        label={getNumericSeries.name}
                        content={
                            <Text weight="bold" size="larger">
                                {getNumericSeries.dataset[0]
                                    ? new Money(
                                          getNumericSeries.dataset[0],
                                          constants.fractionDigits
                                      ).toStringWithCurrency()
                                    : constants.noValue}
                            </Text>
                        }
                        tooltip={getNumericSeries.tooltip ? getNumericSeries.tooltip : undefined}
                    />
                )}
                {getPercentageSerires && getPercentageSerires.dataset.length > 0 && (
                    <LabeledReportItem
                        label={getPercentageSerires.name}
                        content={
                            <Text weight="bold" size="larger">
                                {formatNumberOrEmtpy(getPercentageSerires.dataset[0], true)}
                            </Text>
                        }
                        tooltip={getPercentageSerires.tooltip ? getPercentageSerires.tooltip : undefined}
                    />
                )}
            </Flex>
        );
    };

    return <ReportBox title={props.report.name || ""} content={getCumulative()} />;
};
